import script from "./PageMyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PageMyPage.vue?vue&type=script&setup=true&lang=js"

import "./PageMyPage.vue?vue&type=style&index=0&id=10b655e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b655e8"]])

export default __exports__